module.exports = __webpack_public_path__ + "img/hiden_btn.93a20a81.png";